import React from 'react';

import styles from './Title.module.css';
import Card from '../UI/Card/Card';
const Title = () => {
  return (
    <Card className={styles.title}>
      Medical Cannabidiol Board Recommendations
    </Card>
  );
};

export default Title;
